import { ErrorNotification } from '@sleepstation/components'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import RoutingContext from '../../../context/RoutingContext'
import BreakoutModuleNarrow from '../../shared/breakoutModules/BreakoutModuleNarrow'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const TITLE = `We’ve experienced a problem loading a part of your report`
const BODY = `We’ve notified our developers about this problem and they’ll work to resolve it ASAP. If you need access to your report today, just send us a message and our team will be able to help`
const LINK_LABEL = `Send us a message`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const SleepPatternsTableErrorNotification = ({ ...props }) => {
  const { appRouting } = useContext(RoutingContext)
  const linkUrl = appRouting.chatMessagesPath
  return (
    <BreakoutModuleNarrow
      hasBottomBorder={false}
      hasGradient={false}
      paddingV={[[0, 0.5]]}
    >
      <ErrorNotification
        title={TITLE}
        body={BODY}
        linkLabel={LINK_LABEL}
        linkUrl={linkUrl}
        {...props}
      />
    </BreakoutModuleNarrow>
  )
}

SleepPatternsTableErrorNotification.propTypes = {
  exceptionId: PropTypes.string.isRequired,
}

export default SleepPatternsTableErrorNotification
